var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionBasic',{attrs:{"id":"mission","isActive":_vm.isActive}},[_c('h3',{staticClass:"txt_section"},[_vm._v("Our mission")]),_c('p',{staticClass:"desc_mission"},[_vm._v("레몬트리는 자녀의 미래에"),_c('br'),_vm._v("부가 따를 수 있게 한다는 "),_c('span',{staticClass:"txt_break_response"},[_vm._v("미션을 수행합니다.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }